import { motion, useTransform } from "framer-motion";
import { EASE } from "./motion";

const RotatingBadge = () => (
  <div className="absolute -left-6 -top-6 z-20 h-28 w-28 sm:-left-10 sm:-top-10 sm:h-32 sm:w-32" data-testid="hero-rotating-badge">
    <svg viewBox="0 0 120 120" className="spin-slow h-full w-full">
      <defs>
        <path id="circ" d="M60,60 m-46,0 a46,46 0 1,1 92,0 a46,46 0 1,1 -92,0" />
      </defs>
      <circle cx="60" cy="60" r="58" fill="#E4E4E4" stroke="#000" strokeWidth="2" />
      <text className="fill-neutral-900 font-mono font-bold" fontSize="8.6" letterSpacing="1.6">
        <textPath href="#circ" textLength="286">CLEANING · FLOOR CARE · MAINTENANCE · </textPath>
      </text>
    </svg>
    <div className="absolute inset-0 grid place-items-center">
      <img src="/img/logo.png" alt="" className="h-[52%] w-[52%] object-contain" />
    </div>
  </div>
);

export const HeroFrame = ({ mx, my, progress }) => {
  const rotateY = useTransform(mx, [0, 1], [-7, 7]);
  const rotateX = useTransform(my, [0, 1], [6, -6]);
  const imgY = useTransform(progress, [0, 1], ["-6%", "10%"]);

  return (
    <div className="relative mx-auto max-w-md lg:mt-6 lg:max-w-none" style={{ perspective: 1200 }}>
      <motion.div
        initial={{ clipPath: "inset(100% 0% 0% 0%)" }}
        animate={{ clipPath: "inset(0% 0% 0% 0%)" }}
        transition={{ duration: 1.4, delay: 0.5, ease: EASE }}
        style={{ rotateX, rotateY, transformStyle: "preserve-3d" }}
        className="relative"
      >
        <div className="cut-corner relative aspect-[4/5] max-h-[78vh] w-full overflow-hidden bg-zinc-900">
          <motion.img
            src="/img/hero.jpg"
            alt="Technician in high-visibility gear power-cleaning a commercial floor"
            style={{ y: imgY, scale: 1.18 }}
            className="absolute inset-0 h-full w-full object-cover"
            data-testid="hero-image"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-[#0A0A0A]/85 via-transparent to-transparent" />
          <div className="absolute bottom-0 left-0 right-0 flex items-end justify-between p-6 pr-[18%]">
            <div>
              <div className="font-mono text-[11px] uppercase tracking-[0.22em] text-brand-300">Floor care / on site</div>
              <div className="mt-1 font-display text-xl font-bold text-white">Central Pennsylvania</div>
            </div>
            <div className="font-mono text-[11px] text-zinc-300">40.24°N 76.92°W</div>
          </div>
        </div>
        <div className="pointer-events-none absolute -bottom-3 -right-3 h-full w-full border border-brand-400/40 cut-corner-outline" style={{ transform: "translateZ(-40px)" }} />
      </motion.div>
      <RotatingBadge />
    </div>
  );
};
